import { StyledSamLogo } from './styles';

export const SamLogo = ({ className }: { className?: string }) => (
  <StyledSamLogo
    width="34"
    height="18"
    viewBox="0 0 34 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M27.8876 7.75103L29.0814 5.08662L31.7078 3.87552L29.0814 2.66442L27.8876 0L26.6938 2.66442L24.0674 3.87552L26.6938 5.08662L27.8876 7.75103Z"
      fill="url(#paint0_radial_2104_63313)"
    />
    <g clipPath="url(#clip0_2104_63313)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.04481 17.4906C3.7621 17.8096 4.60531 17.9686 5.57442 17.9686C6.56872 17.9686 7.39243 17.8096 8.04717 17.4906C8.70191 17.1717 9.19256 16.7564 9.51993 16.2446C9.8473 15.7213 10.0106 15.1749 10.0106 14.6063C10.0106 13.947 9.86598 13.4064 9.57679 12.9853C9.2876 12.5642 8.88468 12.2173 8.36885 11.9445C7.8652 11.6602 7.29251 11.4163 6.65076 11.2111C6.04639 11.0174 5.50537 10.841 5.02691 10.682C4.56144 10.5221 4.16502 10.3573 3.83765 10.1867C3.51109 10.0046 3.26495 9.79445 3.10167 9.55546C2.9384 9.31647 2.85635 9.01486 2.85635 8.65061C2.85635 8.21796 2.95708 7.86525 3.15854 7.59247C3.37218 7.3197 3.66219 7.12027 4.02692 6.99501C4.40466 6.85821 4.82626 6.78981 5.29173 6.78981C5.88311 6.78981 6.36726 6.88623 6.74499 7.07989C7.13492 7.27355 7.4306 7.52902 7.63206 7.84794C7.83352 8.16687 7.93425 8.52535 7.93425 8.92338H9.59548C9.59548 8.27482 9.4192 7.7062 9.06665 7.21669C8.71409 6.71647 8.22344 6.32337 7.59388 6.03906C6.97732 5.75475 6.25922 5.61218 5.40383 5.61218C4.54844 5.61218 3.80597 5.74898 3.17722 6.02258C2.56066 6.29535 2.08219 6.67114 1.74264 7.14911C1.41527 7.62709 1.25199 8.17264 1.25199 8.78741C1.25199 9.55052 1.51031 10.1875 2.02614 10.6993C2.55416 11.1995 3.37868 11.6264 4.49889 11.9791C4.98954 12.1266 5.46801 12.275 5.93347 12.4225C6.39894 12.5593 6.82054 12.7241 7.19828 12.9178C7.58901 13.1114 7.8912 13.3562 8.10484 13.652C8.33148 13.9363 8.4444 14.3121 8.4444 14.7439C8.4444 15.1758 8.32417 15.5458 8.08535 15.8532C7.84571 16.149 7.51265 16.3765 7.08455 16.5355C6.65645 16.683 6.1593 16.7572 5.5931 16.7572C4.88881 16.7572 4.30312 16.6435 3.83765 16.416C3.37218 16.177 3.02613 15.8639 2.79949 15.4774C2.57284 15.0793 2.45993 14.6467 2.45993 14.1803H0.798706C0.798706 14.931 0.993666 15.5911 1.38359 16.1597C1.77351 16.7284 2.32752 17.1717 3.04481 17.4906ZM14.8621 5.78131L10.6753 17.9688V17.9696H12.1855L13.0186 15.4931H18.6955L19.5127 17.9688H21.0399L16.9214 5.78131H14.8621ZM18.3045 14.3089L15.9092 7.05288H15.858L13.417 14.3089H18.3045ZM21.8872 5.78131V17.9688H23.3291V8.09701H23.3803L27.0017 16.2275H28.7864L32.3907 8.09701H32.4419V17.9688H33.8838V5.78131H31.8757L27.9277 14.8175H27.8765L23.9123 5.78131H21.8872Z"
        fill="url(#paint1_linear_2104_63313)"
      />
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_2104_63313"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(29.7213 1.76704) rotate(115.145) scale(5.39435 9.4789)"
      >
        <stop stopColor="#02C79E" />
        <stop offset="1" stopColor="#1283DB" />
      </radialGradient>
      <linearGradient
        id="paint1_linear_2104_63313"
        x1="5.67427"
        y1="15.3492"
        x2="5.67427"
        y2="7.23113"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#127EDF" />
        <stop offset="1" stopColor="#04BFA6" />
      </linearGradient>
      <clipPath id="clip0_2104_63313">
        <rect width="34" height="12.4017" fill="white" transform="translate(0 5.59845)" />
      </clipPath>
    </defs>
  </StyledSamLogo>
);
